import { useState, useEffect, useRef } from "react";

interface DurationDisplayProps {
  running: boolean;
  getElapsedMs: () => number;
}

function formatTime(seconds: number): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  return [h, m, s].map((v) => String(v).padStart(2, "0")).join(":");
}

export function DurationDisplay({ running, getElapsedMs }: DurationDisplayProps) {
  const [displaySeconds, setDisplaySeconds] = useState(0);
  const rafRef = useRef<number | null>(null);
  const getElapsedMsRef = useRef(getElapsedMs);
  getElapsedMsRef.current = getElapsedMs;

  useEffect(() => {
    if (running) {
      const tick = () => {
        setDisplaySeconds(Math.floor(getElapsedMsRef.current() / 1000));
        rafRef.current = requestAnimationFrame(tick);
      };
      rafRef.current = requestAnimationFrame(tick);
    } else {
      if (rafRef.current !== null) {
        cancelAnimationFrame(rafRef.current);
        rafRef.current = null;
      }
      setDisplaySeconds(Math.floor(getElapsedMsRef.current() / 1000));
    }

    return () => {
      if (rafRef.current !== null) {
        cancelAnimationFrame(rafRef.current);
        rafRef.current = null;
      }
    };
  }, [running]);

  return (
    <div className="text-center">
      <p className="text-white text-[3.5rem] font-thin tracking-[0.12em] tabular-nums leading-none">
        {formatTime(displaySeconds)}
      </p>
      <p className="text-[#3dd8c0] text-[8px] tracking-[0.32em] uppercase mt-2">
        Hours&nbsp;&nbsp;:&nbsp;&nbsp;Minutes&nbsp;&nbsp;:&nbsp;&nbsp;Seconds
      </p>
    </div>
  );
}
